/*
 *
 * Preferences constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/Preferences';

export const DEFAULT_ACTION = 'app/Preferences/DEFAULT_ACTION';

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_PREFERENCES_DATA = `${BASE_ACTION_CONSTANT}/GET_PREFERENCES_DATA`;

export const SET_ORDER_EXPIRY_TIME = `${BASE_ACTION_CONSTANT}/SET_ORDER_EXPIRY_TIME`;

export const SET_TRANSACTION_COMPLETE_TIME = `${BASE_ACTION_CONSTANT}/SET_TRANSACTION_COMPLETE_TIME`;

export const GET_ORDER_EXPIRY_TIME_URL = '/pg/order-expiry';

export const GET_TRANSACTION_COMPLETE_TIME_URL = '/pg/pg-config';

export const INSTANT_REFUND_STATUS = `${BASE_ACTION_CONSTANT}/INSTANT_REFUND_STATUS`;

export const UPDATE_DEFAULT_REFUND_SPEED = `${BASE_ACTION_CONSTANT}/UPDATE_DEFAULT_REFUND_SPEED`;

export const UPDATE_NOTIFICATION_GROUP = `${BASE_ACTION_CONSTANT}/UPDATE_NOTIFICATION_GROUP`;

export const SET_ORDER_EXPIRY_TIME_URL = {
  url: '/pg/order-expiry',
  method: 'POST',
};

export const SET_TRANSACTION_COMPLETE_TIME_URL = {
  url: '/pg/pg-config',
  method: 'POST',
};

export const UPDATE_DEFAULT_REFUND_SPEED_URL = {
  method: 'PATCH',
  url: '/pg/merchant-pg-config',
};

export const UPDATE_NOTIFICATION_GROUP_URL = {
  url: '/pg/merchant-pg-config',
};

export const PROCESSING_FEE_MODAL = 'PROCESSING_FEE_MODAL';

export const INSTANT_REFUNDS = 'INSTANT_REFUNDS';

export const DEFAULT_REFUND_SPEED = 'DEFAULT_REFUND_SPEED';

export const MERCHANT_EMAIL_ENABLED = 'MERCHANT_EMAIL_ENABLED';

export const ACTIVE = 'ACTIVE';

export const INACTIVE = 'INACTIVE';
